export const answerQuestion = '/api/questionnaire/v1/';
export const SCAN_QUESTION = '/api/v1/scan/scanId/question';
export const SCAN_INIT = '/api/v1/scan/init';
export const SCAN_COMPLETE = '/api/v1/scan/scanId/complete';
export const SCAN_IS_COMPLETE = '/api/v1/scan/scanId/isComplete';
export const SCAN_CURRENT = '/api/v1/scan/current';
export const SCAN_DRAFT = '/api/v1/scan/draft/';
